import React, { Component } from 'react';
import avatar from '../me-web.gif';
import Leftbar from '../components/Leftbar';
import SEO from '../components/SEO/SEO'; 

class Home extends Component {
    render() {
        return (
            <>
                <SEO />
                <Leftbar />
                <div className="container">
                    <div className="row main-section justify-content-md-center align-items-center">
                    <div className="col">
                        <img src={avatar} className="avatar-style" alt="avatar" />
                    </div>
                    <div className="col">
                        <small>Hi!</small>
                        <h3>I'm Jesús Cortés,</h3>
                        <p>frontend developer based in <span role="img" aria-label="mexican-flag">🇲🇽</span> (Mexico) specializing in building (and occasionally designing) websites. I'm currently avaiable for web development projects. </p>
                    </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Home;